<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-tabs v-model="activeTab" @tab-click="tabHandleClick">
            <el-tab-pane label="基本信息" name="baseinfo">
              <div v-loading="true" style="height:1000px"></div>
            </el-tab-pane>

            <el-tab-pane label="办理国家" name="country">
              <!--办理国家：开始-->
              <div class="power-left-wrap">
                <label>设置办理国家</label>
              </div>
              <div class="power-right-wrap" v-loading="loading">
                <el-select v-model="countryIds" style="width:100%" multiple placeholder="请选择">
                  <el-option
                    v-for="item in countryList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
                <div class="jm-primary">
                  <el-button type="primary" @click="countryEditSave" :disabled="loading">更新办理国家</el-button>
                </div>
              </div>
              <!--办理国家：结束-->
            </el-tab-pane>

            <el-tab-pane label="推广渠道" name="channel">
              <!--推广渠道绑定：开始-->
              <div class="power-left-wrap">
                <el-tree
                  :data="channelData"
                  node-key="id"
                  show-checkbox
                  highlight-current
                  ref="channelTree"
                  :expand-on-click-node="false"
                  @check="treeHandleCheck"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span v-if="data.color" :style="`color: ${data.color}`" :title="`渠道编号： ${data.id}`">
                      {{ node.label }}
                    </span>
                    <span v-else :title="`渠道编号： ${data.id}`">
                      {{ node.label }}
                    </span>
                  </span>
                </el-tree>
              </div>
              <div class="power-right-wrap" v-loading="loading">
                <div class="tag-group">
                  <el-alert v-if="!channelTags.length" title="请从右侧选择推广渠道，点击底部按钮进行绑定" type="info" show-icon />
                  <el-tag closable v-for="tag in channelTags" :key="tag.id" type="warning" :disable-transitions="false" @close="channelCloseTag(tag)">
                    {{ tag.name }}
                  </el-tag>
                </div>
                <div class="jm-primary">
                  <el-button type="primary" @click="channelEditSave" :disabled="loading">更新推广渠道绑定</el-button>
                </div>
              </div>
              <!--推广渠道绑定：结束-->
            </el-tab-pane>

            <el-tab-pane label="钉钉账号" name="dingtalk">
              <!--钉钉账号绑定：开始-->
              <div class="power-left-wrap">
                <div class="left-search-area">
                  <el-input placeholder="搜索钉钉账号" v-model="keyword" clearable>
                    <el-button slot="append" icon="el-icon-search" @click="userBindSearch('dingtalk')" />
                  </el-input>
                  <div v-loading="loading">
                    <el-checkbox-group v-model="dingtalkTags">
                      <el-checkbox
                        v-for="user in dingtalkData"
                        :label="user"
                        :key="user.uid"
                        border
                        size="small"
                        style="margin:5px;">
                        {{ user.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <div class="power-right-wrap">
                <el-alert v-if="!dingtalkTags.length" title="请从右侧搜索钉钉账号，点击底部按钮进行绑定" type="info" show-icon />
                <div class="tag-group">
                  <el-tag closable v-for="tag in dingtalkTags" :key="tag.uid" :disable-transitions="false" @close="dingtalkCloseTag(tag)">
                    {{ tag.name }}
                  </el-tag>
                </div>
                <div class="jm-primary">
                  <el-button type="primary" @click="userBindSave('dingtalk')" :disabled="loading">更新钉钉账号绑定</el-button>
                </div>
              </div>
              <!--钉钉账号绑定：结束-->
            </el-tab-pane>

            <el-tab-pane label="企业微信" name="wework">
              <!--钉钉账号绑定：开始-->
              <div class="power-left-wrap">
                <div class="left-search-area">
                  <el-input placeholder="搜索企业微信" v-model="keyword" clearable>
                    <el-button slot="append" icon="el-icon-search" @click="userBindSearch('wework')" />
                  </el-input>
                  <div v-loading="loading">
                    <el-checkbox-group v-model="weworkTags">
                      <el-checkbox
                        v-for="user in weworkData"
                        :label="user"
                        :key="user.uid"
                        border
                        size="small"
                        style="margin:5px;">
                        {{ user.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <div class="power-right-wrap">
                <el-alert v-if="!weworkTags.length" title="请从右侧搜索企业微信，点击底部按钮进行绑定" type="info" show-icon />
                <div class="tag-group">
                  <el-tag closable v-for="tag in weworkTags" :key="tag.id" type="success" :disable-transitions="false" @close="weworkCloseTag(tag)">
                    {{ tag.name }}
                  </el-tag>
                </div>
                <div class="jm-primary">
                  <el-button type="primary" @click="userBindSave('wework')" :disabled="loading">更新企业微信绑定</el-button>
                </div>
              </div>
              <!--钉钉账号绑定：结束-->
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      refresh: false,
      activeTab: 'channel',
      channelData: [],
      channelTags: [],
      dingtalkData: [],
      dingtalkTags: [],
      weworkData: [],
      weworkTags: [],
      countryIds: [],
      countryList: [],
      keyword: ''
    };
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http._get({
        url: '/index/power/userChannelList',
        data: {
          userid: this.adminId
        }
      })
        .then((data) => {
          this.loading = false;
          this.channelData = data.data.channelTree;
          this.channelTags = data.data.channelNames;
          this.dingtalkTags = data.data.dingtalkBinds;
          this.weworkTags = data.data.weworkBinds;
          this.countryIds = data.data.countryIds;
          this.countryList = data.data.countryList;
          this.$refs.channelTree.setCheckedKeys(data.data.channelIds);
        });
    },
    treeHandleCheck(data, checked) {
      this.loading = true;
      this.$http._post({
        url: '/index/power/getChannelFullName',
        data: { channelIds: checked.checkedKeys }
      })
        .then((data) => {
          this.loading = false;
          this.channelTags = data.data.channelNames;
        });
    },
    channelCloseTag(tag) {
      // 删除标签
      this.channelTags = this.channelTags.filter((item) => {
        return item.id !== tag.id;
      });

      // 根据channelTags算出Tree的checkedKey
      let checked = [];
      this.channelTags.forEach((item) => {
        checked.push(item.id);
      });
      this.$refs.channelTree.setCheckedKeys(checked);
    },
    // 编辑部门弹窗保存
    channelEditSave() {
      this.loading = true;
      this.$http._post({
        url: '/index/power/userChannelEdit',
        data: {
          userid: this.adminId,
          channels: this.channelTags
        }
      })
        .then((data) => {
          this.$message({ message: data.msg, type: data.result !== 0 ? 'error' : 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 编辑办理国家
    countryEditSave() {
      this.loading = true;
      this.$http._post({
        url: '/index/power/editTeacherCountry',
        data: {
          userid: this.adminId,
          country_ids: this.countryIds
        }
      })
        .then((data) => {
          this.$message({ message: data.msg, type: data.result !== 0 ? 'error' : 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 切换tab
    tabHandleClick(tab) {
      if (tab.name === 'baseinfo') {
        this.$router.push({ name: 'adminEdit', params: { id: this.adminId } });
      }
      this.keyword = '';
      this.dingtalkData = [];
      this.weworkData = [];
    },
    // 用户绑定搜索
    userBindSearch(type) {
      if (!this.keyword) { return; }

      this.loading = true;
      this.$http._post({
        url: '/index/power/userBindSearch',
        data: {
          type: type,
          keyword: this.keyword
        }
      })
        .then((data) => {
          if (type === 'dingtalk' || type === 'wework') {
            this[`${type}Data`] = data.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 用户绑定保存
    userBindSave(type) {
      this.$confirm('此操作将更新账号绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http._post({
          url: '/index/power/userBindSave',
          data: {
            type: type,
            userid: this.adminId,
            binds: this[`${type}Tags`]
          }
        })
          .then((data) => {
            this.$message({ message: data.msg, type: data.result !== 0 ? 'error' : 'success' });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // 关闭标签
    dingtalkCloseTag(tag) {
      this.dingtalkTags = this.dingtalkTags.filter((item) => {
        return item.uid !== tag.uid;
      });
    },
    weworkCloseTag(tag) {
      this.weworkTags = this.weworkTags.filter((item) => {
        return item.uid !== tag.uid;
      });
    }
  },
  computed: {
    adminId() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return null;
    }
  },
  beforeMount() {
    this.fetchData();

    // console.info(this.$route);
    if (this.$route.hash) {
      this.activeTab = this.$route.hash.replace('#', '');
    }
  },
};
</script>
<style scoped>
.tag-group .el-tag--medium {
  height: auto;
  line-height: 200%;
  font-size: 14px;
}

.tag-group .el-tag {
  margin: 5px;
}

.jm-primary {
  border-top: 1px solid #f0f0f0;
  margin: 20px 0;
  padding: 20px;
  text-align: center;
}

.power-left-wrap {
  float: left;
  padding-left: 15px;
  width: 290px;
  height: 100%;
  min-height: 500px;
}

.power-left-wrap .title-area {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f0f0f0;
}

.power-left-wrap .left-search-area {
  padding-right: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.power-right-wrap {
  margin-left: 290px;
  padding-left: 10px;
  border-left: 1px solid #f0f0f0;
}

.custom-tree-node {
  width: 100%;
}

.custom-tree-node::after {
  clear: both;
  display: block;
  content: "";
}

.custom-tree-node>span {
  line-height: 26px;
  float: left;
}

.custom-tree-node>span:nth-of-type(2) {
  float: right;
  padding-right: 10px;
  font-size: 0;
  display: none;
  height: 26px;
  overflow: hidden;
}

.custom-tree-node>span:nth-of-type(2) .el-button {
  padding: 0;
}

.custom-tree-node:hover>span:nth-of-type(2) {
  display: block;
}

.custom-tree-node .el-button {
  line-height: 26px;
  font-size: 0;
}

.custom-tree-node .el-button img {
  display: inline-block;
  vertical-align: middle;
  width: 14px;
}</style>
<style scoped>
.tag-group .el-tag--medium {
  height: auto;
  line-height: 200%;
  font-size: 14px;
}
.tag-group .el-tag {
  margin: 5px;
}
.jm-primary {
  border-top: 1px solid #f0f0f0;
  margin: 20px 0;
  padding: 20px;
  text-align: center;
}
.power-left-wrap {
  float: left;
  padding-left: 15px;
  width: 290px;
  height: 100%;
  min-height: 500px;
}
.power-left-wrap .title-area {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f0f0f0;
}
.power-left-wrap .left-search-area {
  padding-right: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.power-right-wrap {
  margin-left: 290px;
  padding-left: 10px;
  border-left: 1px solid #f0f0f0;
}
.custom-tree-node {
  width: 100%;
}
.custom-tree-node::after {
  clear: both;
  display: block;
  content: "";
}
.custom-tree-node>span {
  line-height: 26px;
  float: left;
}
.custom-tree-node>span:nth-of-type(2) {
  float: right;
  padding-right: 10px;
  font-size: 0;
  display: none;
  height: 26px;
  overflow: hidden;
}
.custom-tree-node>span:nth-of-type(2) .el-button {
  padding: 0;
}
.custom-tree-node:hover>span:nth-of-type(2) {
  display: block;
}
.custom-tree-node .el-button {
  line-height: 26px;
  font-size: 0;
}
.custom-tree-node .el-button img {
  display: inline-block;
  vertical-align: middle;
  width: 14px;
}
</style>
